// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"702":"story","715":"list"}[chunkId] || chunkId) + "-" + {"77":"1eac270cb393d1a13e69","702":"d3ed2b6038a2334ca187","715":"34dd6ecb43cd754170af"}[chunkId] + ".css";
};